import React, { useState, useEffect, useRef  } from "react" ;
import axios from 'axios'
import PaypalCheckoutMain from "./PaypalCheckoutMain";

const PaypalCheckout = () => {
   

    return (
        <PaypalCheckoutMain
        amountTotal="15.00"
        hsk="_hsk1"
        hskNumber="1"
      />
    );
}

export default PaypalCheckout